import ShadowBox from "components/common/ShadowBox/ShadowBox";
import { useContext, useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  Flex,
  Tooltip,
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { AiFillEye } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import { HiOutlineRefresh } from "react-icons/hi";
import { Paginationlimit } from "components/common/functions/variable";
import _ from "lodash";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import TableLoader from "components/common/TableLoader/TableLoader";
import Pagination from "components/common/Pagination/Pagination";
import ModelButton from "../CustomOnboarding/CustomOnboarding/component/Forms/dummyFormData";
import DeleteFormModal from "../forms/component/DeleteFormModal";
import EditFormModal from "../forms/component/EditFormModal";
import ViewFormModal from "../forms/component/ViewFormModal";

type WorkFlow = {
  _id?: string;
  username: string;
  name: string;
  defaultActive: boolean;
  values: any;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
};

function FormTable() {
  const { toastNotify, accountDetails } = useContext(AppContext);
  const [data, setData] = useState<WorkFlow[]>([]);
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState<any>({
    page: 1,
    data: null,
  });
  const [isOpen, setIsOpen] = useState<any>({
    open: false,
    data: null,
  });

  const [openEditModel, setOpenEditModel] = useState<any>({
    open: false,
    data: null,
  });

  const [openDeleteModel, setOpenDeleteModel] = useState<any>({
    open: false,
    data: null,
  });

  console.log("data", activePage.data);

  // for Preview Modal
  const handleOpenEditForm = (item: any) => {
    setOpenEditModel({
      open: true,
      data: { ...item },
    });
  };
  const handleCloseEditForm = () => {
    setOpenEditModel({
      open: false,
      data: null,
    });
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  // get form api call temporary called here for testing.

  const handleGetForm = async (currentP?: number, valu?: any) => {
    try {
      setLoading(true);
      let value = valu ? valu : search;
      let limit = Paginationlimit;
      let sort = 1;
      let page = currentP ? currentP : currentPage;
      let object: any = {
        value,
        limit,
        sort,
        page,
        activeWorkflow:accountDetails?.defaultWorkflow
      };

      const response: any = await appRequest("form", "get", object);
      if (response) {
        if (Array.isArray(response?.data)) {
          setData(response?.data);
          setTotalPages(response?.totalPages);
        } else {
          toastNotify({
            title: `Error getting the forms`,
            message: response?.message || "Something went wrong.",
            type: "error",
          });
        }
      } else {
        toastNotify({
          title: `Error getting the forms.`,
          message: "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the forms.`,
        message: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialLoad) {
      handleGetForm(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = _.debounce((search) => {
        handleGetForm(currentPage, search);
      }, 1000);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [search, currentPage]);

  return (
    <>
      {activePage.page === 1 && (
        <ShadowBox>
          <Flex
            justifyContent="end"
            alignItems="center"
            gap={{ base: 2, lg: 4 }}
            mb={5}
          >
            <SearchBox
              onSearch={() => {}}
              setValue={setSearch}
              value={search}
            />
            <Box display={{ base: "none", md: "block" }}>
              <Button
                border="2px solid"
                borderColor="teal.300"
                bg="white"
                fontSize="sm"
                color="teal.400"
                _hover={{ bg: "teal.300", color: "white" }}
                onClick={() => {
                  setSearch("");
                  setCurrentPage(1);
                  handleGetForm();
                }}
              >
                <HiOutlineRefresh fontSize="1.2rem" />
              </Button>
            </Box>
            <Box display={{ base: "none", md: "block" }}></Box>
            <Box display={{ base: "block", md: "none" }}>
              <Popover>
                <PopoverTrigger>
                  <Button
                    bg="teal.300"
                    color="white"
                    _hover={{ bg: "teal.400" }}
                  >
                    Action
                  </Button>
                </PopoverTrigger>
                <PopoverContent maxW="180px">
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody>
                    <Flex
                      alignItems="center"
                      gap={2}
                      justifyContent="space-between"
                    >
                      <Box mt={4}></Box>
                      <Box mt={4}>
                        <Button
                          border="2px solid"
                          borderColor="teal.300"
                          bg="white"
                          fontSize="sm"
                          color="teal.400"
                          _hover={{ bg: "teal.300", color: "white" }}
                          onClick={() => {
                            setSearch("");
                            setCurrentPage(1);
                            handleGetForm();
                          }}
                        >
                          <HiOutlineRefresh fontSize="1.2rem" />
                        </Button>
                      </Box>
                    </Flex>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Box>
          </Flex>
          <Box
            position="relative"
            // width={{ lg: "calc(100vw - 13.8rem)" }}
            overflow="auto hidden"
            className="customScrollBar"
          >
            <Table variant="striped">
              <Thead>
                <Tr>
                  <Th>Form Name</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <TableLoader loader={loading} show={data.length}>
                <Tbody>
                  {data.map((item: any, index: number) => (
                    <Tr key={index}>
                      <Td whiteSpace="nowrap">{item?.formName}</Td>
                      <Td>
                        <Flex alignItems="center" justifyContent="end">
                          <Tooltip label="View Form" hasArrow arrowSize={15}>
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              color="green.500"
                              //   onClick={() => {handleViewOpenModal(item)}}
                              _hover={{ color: "green.600" }}
                              onClick={() =>
                                {setActivePage({ page: 2, data: { ...item } })}
                              }
                            >
                              <Box mr=".5rem" fontSize="1.4rem">
                                <AiFillEye />
                              </Box>
                            </Flex>
                          </Tooltip>
                          <Tooltip label="Edit Form" hasArrow arrowSize={15}>
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              mx="1rem"
                              color="green.500"
                              onClick={() => {
                                handleOpenEditForm(item);
                              }}
                              _hover={{ color: "green.600" }}
                            >
                              <Box mr=".5rem">
                                <FaEdit />
                              </Box>
                            </Flex>
                          </Tooltip>
                          <Tooltip label="Delete Form" hasArrow arrowSize={15}>
                            <Flex
                              alignItems="center"
                              cursor="pointer"
                              color="red.500"
                              onClick={() => {
                                setOpenDeleteModel({
                                  open: true,
                                  data: item,
                                });
                              }}
                              _hover={{ color: "red.600" }}
                            >
                              <Box mr=".5rem">
                                <RiDeleteBin5Line />
                              </Box>
                            </Flex>
                          </Tooltip>
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </TableLoader>
            </Table>
          </Box>
          <Pagination
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
          {/* <ModelButton
            elements={isOpen?.data?.elements}
            designElements={isOpen?.data?.designElements}
            isOpen={isOpen.open}
            onClose={handleCloseForm}
          />{" "} */}
          <DeleteFormModal
            isOpen={openDeleteModel.open}
            onClose={() => {
              setOpenDeleteModel({ data: null, open: null });
            }}
            id={openDeleteModel?.data?._id}
            status={openDeleteModel?.data?.defaultActive}
            handleGet={handleGetForm}
            key={`delete-${openDeleteModel?.data?._id}`}
          />

          <EditFormModal
            isOpen={openEditModel.open}
            onClose={() => handleCloseEditForm()}
            id={openEditModel?.data?._id}
            handleGet={handleGetForm}
            formValues={openEditModel?.data}
          />
        </ShadowBox>
      )}

      {activePage.page === 2 && (
        <ViewFormModal
          elements={activePage.data?.values[0]?.elements}
          designElements={activePage.data?.values[0]?.designElements}
          activePage={activePage}
          setActivePage={setActivePage}
        />
      )}
    </>
  );
}

export default FormTable;
